export const mergeUrlList = [ // 在中国大陆访问这些域名时，需要调用接口来判断是否展示红框
  'vps.wikifxen.com',
  'vps.wikifxvn.com',
  'vps.wikifxvi.com',
  'vps.wikifxzh.com',
  'vps.wikifxka.com',
  'vps.fxeyeka.com',
  'vps.fxeyema.com',
  'vps.fxeyecn.com',
  'vps.fxeyetips.com',
  'vps.fxeyevip.com',
  'vps.wikifxtips.com',
  'vps.wikifx25.com',
  'vps.fxeye25.com',
  'vips.wikifx.hk'
]

export const noRiskUrlList = [ // 这些域名不展示红框逻辑
  'vps.tianyanweb.com',
  'vps.wikifxcn.com'
]
